import {GET, POST} from "../util";

const inspectionUrl = "api/company-data-inspection";
const operationUrl = "api/company-data-operation";

const url = {
	inspection: {
		data: `${inspectionUrl}/data`,
		putOptionSettingStatus: `${inspectionUrl}/put-option-setting/status`,
		getCompanyInsurancePolicyHolderStatus: `${inspectionUrl}/tci/status`
	},
	operation: {
		applyPutOptionTrading: `${operationUrl}/put-option-setting/apply-trading`,
		confirmTciRequest: `${operationUrl}/tci/accept`
    }
};

const companyProfileApi = {
    inspection: {
        getData: () => {
            return GET(url.inspection.data);
        },
		getPutOptionSettingStatus: () => {
			return GET(url.inspection.putOptionSettingStatus);
		},
		getCompanyInsurancePolicyHolderStatus: () => {
			return GET(url.inspection.getCompanyInsurancePolicyHolderStatus);
		}
    },
    operation: {
		applyPutOptionTrading: (data) => {
			return POST(url.operation.applyPutOptionTrading, data);
		},
		acceptTciTOS: (data) => {
			return POST(url.operation.confirmTciRequest, data);
		}
    }

};
export {
    companyProfileApi
};